import { Navigate } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import pagesConfigs from 'app/main/pages/pagesConfigs';
import HomeConfig from '../main/Home/HomeConfig'
import ContactConfig from 'app/main/Contact/ContactConfig';
import VerificationsCertificatesConfig from 'app/main/Certifications/Verifications/VerificationsCertificatesConfig';
import PublicTraceabilityConfig from 'app/main/Traceability/PublicTraceabilityConfig';
import DownloadRatesConfig from 'app/main/document/DownloadRatesConfig';
import SolutionsConfig from '../main/Solutions/SolutionsConfig';
import HowItWorksConfig from '../main/HowItWorks/HowItWorksConfig';
import UseCasesConfig from '../main/UseCases/UseCasesConfig';
import EducationConfig from '../main/Education/EducationConfig';

const routeConfigs = [
	...pagesConfigs,
	HomeConfig,
	ContactConfig,
	VerificationsCertificatesConfig,
	PublicTraceabilityConfig,
	DownloadRatesConfig,
	SolutionsConfig,
	HowItWorksConfig,
	UseCasesConfig,
	EducationConfig,
];

const routes = [
	// if you want to make whole app auth protected by default change defaultAuth for example:
	// ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin','staff','user']),
	// The individual route configs which has auth option won't be overridden.
	...FuseUtils.generateRoutesFromConfigs(routeConfigs),
	{
		path: '/',
		element: <Navigate to="/home" replace />
	},
];

export default routes;
